<template>
    <div ref="dropdownParent"
         class="dropdown">
        <div v-show="!isDropdownOpen"
             class="dropdown-placeholder"
             @click="openDropdown">
            <div class="d-flex align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg"
                     fill="none"
                     height="18"
                     width="18"
                     viewBox="0 0 24 24"
                     class="search-icon">
                    <path d="M16.4153 16.4153L20 20M18.5455 11.2727C18.5455 15.2893 15.2894 18.5454 11.2728 18.5454C7.25612 18.5454 4 15.2893 4 11.2727C4 7.2561 7.25612 4 11.2728 4C15.2894 4 18.5455 7.2561 18.5455 11.2727Z"
                          stroke-width="2"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                </svg>
                <div class="placeholder ml-1">
                    <translate translation-key="buy-pages.typeSelectCrypto" />
                </div>
            </div>
            <i class="fa-solid fa-chevron-down down-arrow" />
        </div>
        <div v-if="isDropdownOpen"
             class="dropdown-search">
            <input ref="searchInput"
                   v-model="search"
                   type="text"
                   :placeholder="getTrans('buy-pages.typeSelectCrypto')">
            <div class="close-icon"
                 @click="closeDropdown">
                <svg xmlns="http://www.w3.org/2000/svg"
                     fill="currentColor"
                     height="12"
                     width="12"
                     viewBox="0 0 24 24"
                     class="sc-1pyr0bh-0 KQOVh">
                    <path d="M18 6L6 18M18 18L6 6"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                    <svg />
                </svg>
            </div>
            <div class="dropdown-picker">
                <div v-if="filteredBuyPages.length > 0">
                    <a v-for="(item, index) in filteredBuyPages"
                       :key="index"
                       :href="item.url"
                       class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center w-75">
                            <img class="mr-2 asset-logo asset-logo__24"
                                 width="24"
                                 height="24"
                                 :src="asset_cdn(item.crypto_currency.logo, 22)"
                                 :alt="item.crypto_currency.name">
                            <div class="currency-name mr-2">{{ item.crypto_currency.name }}</div>
                            <div class="ticker">{{ item.crypto_currency.currency_code }}</div>
                        </div>
                        <div class="d-flex align-items-center ranking">
                            #{{ item.crypto_currency.ranking_general }}
                        </div>
                    </a>
                </div>
                <div v-else
                     class="no-results">
                    <translate translation-key="header.searchNoResults" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { asset_cdn } from '@/js/helpers/helpers';
    import { getTrans } from '@/js/helpers/getTrans';

    export default {
        props: {
            buyPages: {
                required: true,
                type: Array,
            },
        },
        data() {
            return {
                isDropdownOpen: false,
                search: '',
            };
        },
        computed: {
            filteredBuyPages() {
                return this.buyPages.filter((item) => item.crypto_currency && (item.crypto_currency.name.toLowerCase().includes(this.search.toLowerCase())
                    || item.crypto_currency.currency_code.toLowerCase().includes(this.search.toLowerCase())));
            },
        },
        mounted() {
            document.addEventListener('click', this.handleClickOutside);
        },
        beforeUnmount() {
            document.removeEventListener('click', this.handleClickOutside);
        },
        methods: {
            getTrans,
            openDropdown() {
                this.isDropdownOpen = true;

                this.$nextTick(() => {
                    this.$refs.searchInput.focus();
                });
            },
            closeDropdown() {
                this.isDropdownOpen = false;
            },
            handleClickOutside(event) {
                if (this.isDropdownOpen) {
                    const search = this.$refs.dropdownParent;
                    const isClickOutsideSearch = search !== event.target && !search.contains(event.target);
                    if (isClickOutsideSearch) {
                        this.closeDropdown();
                    }
                }
            },
            asset_cdn,
        },
    };
</script>
